import React from "react";
import { formatDistance } from "tsi-common-react/src/apps/retail/helpers";
import { useAppSelector } from "tsi-common-react/src/store/reducers";
import { c, t } from "ttag";

import { interpolate } from "@thelabnyc/thelabui/src/utils/i18n";

import { nearestFlagshipStoreSelector } from "../selectors";

export const DistanceToFlagshipStore = (): React.ReactNode => {
    const store = useAppSelector(nearestFlagshipStoreSelector);

    let text: string = t`See Closest Location`;
    if (store && store.distance) {
        const formattedDist = formatDistance(store.distance);
        text = interpolate(c("DistanceToFlagshipStore").t`%s miles away`, [
            formattedDist,
        ]);
    }

    return <>{text}</>;
};
